import { CludoConfig } from "./SearchConfig.js";
import {
  SEARCH_RESULTS_TO_SHOW_DESKTOP,
  SEARCH_RESULTS_TO_SHOW_MOBILE,
  SEARCH_RESULTS_TO_SHOW_STEPSIZE_DESKTOP,
  SEARCH_RESULTS_TO_SHOW_STEPSIZE_MOBILE,
  SEARCH_RESULTS_TO_SHOW_STEPSIZE_TABLET,
  SEARCH_RESULTS_TO_SHOW_TABLET
} from "../../constants/site-search";

let env = document
  .getElementById("env-run-mode-setting")
  ?.getAttribute("data-run-mode");
let currentEngineId = CludoConfig.dev.engineId;
if (env === "stage") {
  currentEngineId = CludoConfig.stage.engineId;
} else if (env === "prod") {
  currentEngineId = CludoConfig.prod.engineId;
} else if (env === "cloud-dev") {
  currentEngineId = CludoConfig.cloudDev.engineId;
}

export const getSuggestionHandler = async (searchTerm, dispatch) => {
  let authString = `${CludoConfig.customerId}:${currentEngineId}:SearchKey`;
  let authStringEncoded = btoa(unescape(encodeURIComponent(authString)));
  let body = {
    responseType: "Json",
    query: searchTerm,
    enableFacetFiltering: "true",
    facets: {
      showInProductFinder: ["true"],
    },
  };
  if (searchTerm.trim() !== "" && searchTerm !== "null") {
    await fetch(
      `${CludoConfig.endpoint}/${CludoConfig.customerId}/${currentEngineId}/Autocomplete?language=&searchEngine=SearchContent&text=${searchTerm}&isInternalSearch=true`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          authorization: `SiteKey ${authStringEncoded}`,
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch({ type: "UPDATE_SUGGESTIONS", payload: json || [] });
      })
      .catch((e) =>
        dispatch({
          type: "UPDATE_SEARCH_ERROR",
          payload:
            "Oops! An error occurred. Search appears to be having problems. Please try again later. If this problem persists please contact support" +
            e,
        }),
      );
  }
};

export const postSearchHandler = async (
  searchTerm,
  dispatch,
  isInitialBlankSearch = false,
) => {
  let term = searchTerm;
  if (term.trim() === "" || searchTerm === "null") {
    term = "*";
  }
  if (!isInitialBlankSearch) {
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchInitiated,
      type: "Page Interaction",
      searchDetails: {
        searchTerm: term,
        type: "Product Finder",
      },
    });
  }

  if (!isInitialBlankSearch) {
    dispatch({ type: "UPDATE_IS_LOADING", payload: true });
    dispatch({ type: "UPDATE_SHOW_RESULTS", payload: false });
  }
  const searchField =
    document.getElementById("product-finder-search-input") ||
    document.getElementById("site-search-input");
  searchField?.blur();

  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_MOBILE", payload: 6 });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_TABLET", payload: 8 });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_DESKTOP", payload: 12 });

  let authString = `${CludoConfig.customerId}:${currentEngineId}:SearchKey`;
  let authStringEncoded = btoa(unescape(encodeURIComponent(authString)));

  let body = {
    responseType: "Json",
    query: term,
    enableFacetFiltering: "true",
    facets: {
      showInProductFinder: ["true"],
    },
    page: 1,
    perPage: 10000,
  };
  await fetch(
    `${CludoConfig.endpoint}/${CludoConfig.customerId}/${currentEngineId}/search`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        authorization: `SiteKey ${authStringEncoded}`,
      },
      body: JSON.stringify(body),
    },
  )
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (!isInitialBlankSearch) {
        dispatch({
          type: "UPDATE_SEARCH_RESULTS_FROM_QUERY",
          payload: json.TypedDocuments,
        });
      } else {
        dispatch({
          type: "UPDATE_COMPLETE_SEARCH_RESULT_SET",
          payload: json.TypedDocuments,
        });
      }
      if (json?.QueryId) {
        dispatch({
          type: "UPDATE_EXTERNEAL_QUERY_ID",
          payload: json?.QueryId,
        });
      }
    })
    .catch((e) =>
      dispatch({
        type: "UPDATE_SEARCH_ERROR",
        payload:
          "Oops! An error occurred. Search appears to be having problems. Please try again later. If this problem persists please contact support" +
          e,
      }),
    );

  if (!isInitialBlankSearch) {
    dispatch({ type: "UPDATE_SHOW_RESULTS", payload: true });
    dispatch({ type: "UPDATE_IS_LOADING", payload: false });
  }
};

export const postSearchHandler_customerSuccess = async (
  searchTerm,
  dispatch,
  isInitialBlankSearch = false,
) => {
  let term = searchTerm;
  if (term.trim() === "" || searchTerm === "null") {
    term = "*";
  }
  if (!isInitialBlankSearch) {
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchInitiated,
      type: "Page Interaction",
      searchDetails: {
        searchTerm: term,
        type: "Product Finder",
      },
    });
  }

  if (!isInitialBlankSearch) {
    dispatch({ type: "UPDATE_IS_LOADING", payload: true });
    dispatch({ type: "UPDATE_SHOW_RESULTS", payload: false });
  }
  const searchField =
    document.getElementById("product-finder-search-input") ||
    document.getElementById("site-search-input");
  searchField?.blur();

  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_MOBILE", payload: 6 });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_TABLET", payload: 6 });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_DESKTOP", payload: 6 });

  let authString = `${CludoConfig.customerId}:${currentEngineId}:SearchKey`;
  let authStringEncoded = btoa(unescape(encodeURIComponent(authString)));

  let body = {
    responseType: "Json",
    query: term,
    enableFacetFiltering: "true",
    facets: {
      showInCustomerSuccess: ["true"],
    },
    page: 1,
    perPage: 10000,
  };
  await fetch(
    `${CludoConfig.endpoint}/${CludoConfig.customerId}/${currentEngineId}/search`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        authorization: `SiteKey ${authStringEncoded}`,
      },
      body: JSON.stringify(body),
    },
  )
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (!isInitialBlankSearch) {
        dispatch({
          type: "UPDATE_SEARCH_RESULTS_FROM_QUERY",
          payload: json.TypedDocuments,
        });
      } else {
        dispatch({
          type: "UPDATE_COMPLETE_SEARCH_RESULT_SET",
          payload: json.TypedDocuments,
        });
      }
      if (json?.QueryId) {
        dispatch({
          type: "UPDATE_EXTERNEAL_QUERY_ID",
          payload: json?.QueryId,
        });
      }
      
    })
    .catch((e) =>
      dispatch({
        type: "UPDATE_SEARCH_ERROR",
        payload:
          "Oops! An error occurred. Search appears to be having problems. Please try again later. If this problem persists please contact support" +
          e,
      }),
    );

  if (!isInitialBlankSearch) {
    dispatch({ type: "UPDATE_SHOW_RESULTS", payload: true });
    dispatch({ type: "UPDATE_IS_LOADING", payload: false });
  }
};

export const postSearchHandler_search = async (
  searchTerm,
  dispatch,
) => {
  dispatch({ type: "UPDATE_IS_LOADING", payload: true });
  dispatch({ type: "UPDATE_SHOW_RESULTS", payload: false });

  let term = searchTerm;
  if (term.trim() === "" || searchTerm === "null" || searchTerm === "*") {
    dispatch({
      type: "UPDATE_SEARCH_RESULTS_FROM_QUERY",
      payload: [],
    });
    dispatch({ type: "UPDATE_SHOW_RESULTS", payload: true });
    dispatch({ type: "UPDATE_IS_LOADING", payload: false });
    return;
  } else {
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchInitiated,
      type: "Page Interaction",
      searchDetails: {
        searchTerm: term,
        type: "Site Search",
      },
    });
  }

  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_MOBILE", payload: SEARCH_RESULTS_TO_SHOW_MOBILE });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_STEPSIZE_MOBILE", payload: SEARCH_RESULTS_TO_SHOW_STEPSIZE_MOBILE });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_TABLET", payload: SEARCH_RESULTS_TO_SHOW_TABLET });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_STEPSIZE_TABLET", payload: SEARCH_RESULTS_TO_SHOW_STEPSIZE_TABLET });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_DESKTOP", payload: SEARCH_RESULTS_TO_SHOW_DESKTOP });
  dispatch({ type: "UPDATE_RESULTS_TO_SHOW_STEPSIZE_DESKTOP", payload: SEARCH_RESULTS_TO_SHOW_STEPSIZE_DESKTOP });

  let authString = `${CludoConfig.customerId}:${currentEngineId}:SearchKey`;
  let authStringEncoded = btoa(unescape(encodeURIComponent(authString)));

  let body = {
    responseType: "Json",
    query: term,
    enableFacetFiltering: "true",
    facets: {
      hideInSearch: ["false"],
    },
    page: 1,
    perPage: 10000,
  };
  await fetch(
    `${CludoConfig.endpoint}/${CludoConfig.customerId}/${currentEngineId}/search`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        authorization: `SiteKey ${authStringEncoded}`,
      },
      body: JSON.stringify(body),
    },
  )
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      dispatch({
        type: "UPDATE_SEARCH_RESULTS_FROM_QUERY",
        payload: json.TypedDocuments,
      });
      if (json?.QueryId) {
        dispatch({
          type: "UPDATE_EXTERNEAL_QUERY_ID",
          payload: json?.QueryId,
        });
      }
    })
    .catch((e) =>
      dispatch({
        type: "UPDATE_SEARCH_ERROR",
        payload:
          "Oops! An error occurred. Search appears to be having problems. Please try again later. If this problem persists please contact support" +
          e,
      }),
    );

  dispatch({ type: "UPDATE_SHOW_RESULTS", payload: true });
  dispatch({ type: "UPDATE_IS_LOADING", payload: false });
};

/**
 * Send request to servlet to notify Cludo that the item was clicked
 * @param componentPath
 * @param itemPath
 */
export const trackClick = (componentPath, itemPath) => {
  fetch(
    `${componentPath}.cludo.statpush.json?itemPath=${encodeURIComponent(
      itemPath,
    )}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    },
  ).catch((e) => {
    console.log("Error sending data to Cludo: ", e);
  });
};
